import { Box, Typography } from '@mui/material'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import React from 'react'
import Rockets from '../../assets/rockets.svg'
import Footsteps from '../../assets/footsteps.svg'
import { useNavigate } from 'react-router-dom'
import { superAdminOnboardingLink } from 'module/sign-up/config/superAdminUrl'
import AdxButton from 'components/custom/AdxButton'

const StepOne = () => {
  const navigate = useNavigate()
  const handleContinue = () => {
    navigate(superAdminOnboardingLink(2))
  }
  return (
    <OnboardingContainer bgColorRight="white.main">
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems="center"
      >
        <Box
          component="img"
          src={Rockets}
          position="fixed"
          bottom={0}
          right={0}
          width="calc(100vw * 0.8)"
          display={{ xs: 'none', lg: 'block' }}
        />
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ xs: '75vh', lg: '500px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2, lg: 0 }}
          position={'relative'}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box mb={4} display="flex" flexDirection="column" alignItems="center">
            <Box component="img" src={Footsteps} width="100px" mb={2} />
            <Typography variant="h1">Few more steps...</Typography>
            <Typography variant="h4" textAlign="justify" color="light-gray-text.main">
              ...then off you go
            </Typography>
          </Box>
          <AdxButton fullWidth onClick={handleContinue}>
            Continue
          </AdxButton>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default StepOne
